"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingState = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const EventsPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/EventsPopover");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const EventsPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPage");
const LoadingState = () => React.createElement(React.Fragment, null,
    React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
            React.createElement(React.Fragment, null, EventsPage_1.PAGE_TITLE),
            React.createElement(EventsPopover_1.EventsPopover, null)) }),
    React.createElement(PageContent_1.default, null,
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(PageLoaderComponent_1.default, null) }))));
exports.LoadingState = LoadingState;
